/** What a store picks during setup and can change on Store Settings. Descriptive only. */
export const STORE_BUSINESS_TYPES = [
  { value: 'retail_store', label: 'Retail Store' },
  { value: 'online_store', label: 'Online Store' },
  { value: 'retail_and_online', label: 'Retail and online' },
  { value: 'wholesale', label: 'Wholesale' },
  { value: 'rental', label: 'Rental' },
  { value: 'service_center', label: 'Service Center' },
  { value: 'other', label: 'Other' },
] as const;

const LEGACY_LABELS: Record<string, string> = {
  retail: 'Retail Store',
  brick_and_mortar: 'Retail Store',
  online_only: 'Online Store',
  both: 'Retail and online',
  hybrid: 'Retail and online',
};

export function businessTypeLabel(value: string): string {
  const known = STORE_BUSINESS_TYPES.find((option) => option.value === value);
  if (known) return known.label;
  return LEGACY_LABELS[value] || value;
}

/** The standard list, plus the store's current value when it predates that list. */
export function businessTypeOptions(current?: string): { value: string; label: string }[] {
  const options: { value: string; label: string }[] = STORE_BUSINESS_TYPES.map((option) => ({
    value: option.value,
    label: option.label,
  }));
  if (current && !options.some((option) => option.value === current)) {
    options.push({ value: current, label: businessTypeLabel(current) });
  }
  return options;
}
